import React, { useState, useEffect } from "react";
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import config from '../../aws-exports';
import { getEsDownDocs, createOnRedis } from '../../graphql/queries';
import Amplify, { API } from 'aws-amplify';
import { useDispatch } from "react-redux";
import Loader from '../../assets/loading.gif';
import secureLocalStorage from "react-secure-storage";
import ForgotPassword from '../Modals/ForgotPassword';
import { useOktaAuth } from "@okta/okta-react";
import oktassoicon from "../../assets/okta.png";

Amplify.configure(config);

// Custom hook to handle Okta auth with SSR support
const useOktaAuthSSR = () => {
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Always call the hook at the top level, but handle the client-side only logic
  const oktaAuthResult = useOktaAuth();

  return {
    oktaAuth: isClient ? oktaAuthResult.oktaAuth : null,
    authState: isClient ? oktaAuthResult.authState : null,
    isClient
  };
};

const Login = (props) => {
  const { consoleLog } = require('../commonFunctions.js');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [generaicError, setgeneraicError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showLoginForm, setshowLoginForm] = useState(false);
  const [proxyToken, setProxyToken] = useState(props.url_params?.token);
  const proxyDocTypeId = props.url_params?.doc_type_id;
  const proxyOrderId = props.url_params?.order_id;
  const dispatch = useDispatch();

  // Use the custom hook that handles SSR
  const { oktaAuth, authState, isClient } = useOktaAuthSSR();

  consoleLog('proxyToken login.jsx props', props);
  if(proxyToken){
    consoleLog('proxyToken is set');
  }

  async function getTokenUser(currentToken) {
    setLoading(true);
    consoleLog('proxyToken getTokenUser');
    consoleLog(currentToken);
    
    let json = {};
    if(currentToken){
      json = {
        proxyToken: currentToken,
        type: 'prodocs'
      }; 
    } else {
      json = {
        userName: email.trim(),
        accessPass: password.trim(),
        type: 'prodocs'
      };    
    }

    let loginUrl = process.env.GATSBY_API_BASE_URL;

    const success = await fetch(`${loginUrl}account/getToken`, {
      method: 'POST',
      body: new URLSearchParams({ json: JSON.stringify(json) }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then(res => res.json())
      .then(json => json);

    if (success.status === 1) {
      if(success.clientData.session_terminated_by_okta == 1){
        setgeneraicError("Access denied, please contact customer support.");
        setLoading(false);
        setshowLoginForm(true);
        return
      }

      let clientData = { ...success.clientData };
      consoleLog('getTokenUser clientData>', clientData);

      secureLocalStorage.setItem('client_data', JSON.stringify(clientData));
      secureLocalStorage.setItem('user_token', success.token);

      const esd = await API.graphql({
        query: getEsDownDocs,
        variables: { team_id: clientData.team_id }
      });
      secureLocalStorage.setItem('es_down_docs', esd.data.getEsDownDocs);

      const create_on_redis = await API.graphql({
        query: createOnRedis,
        variables: {
          id: clientData.client_id,
          index: 'prodocs_user_auth_data',
          data: JSON.stringify(clientData)
        }
      });
      consoleLog('getTokenUser create_on_redis:', create_on_redis);

      if (proxyDocTypeId) {
        navigate(`/createdoc?doc_type_id=${proxyDocTypeId}&order_id=${proxyOrderId}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        const filterEntries = [...params].filter(([k]) => k.startsWith('filter['));

        if (filterEntries.length > 0) {
          const filterQuery = filterEntries
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join('&');
          navigate('/document?' + filterQuery);
        } else {
          navigate('/document');
        }
      }
    } else {
      if(success.code === 403){
        setgeneraicError(success.message);
      }else{
        setgeneraicError('Invalid Credentials');
      }
      setLoading(false);
      setshowLoginForm(true);
    }
  }

  const handleEmailChange = (e) => {
    setEmailError('');
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPasswordError('');
    setPassword(e.target.value);
  };

  const isButtonActive = email.length >= 6 && password.length >= 1;

  const submitValue = () => {
    secureLocalStorage.clear(); // Clear storage when forcing email/password login
    
    if(email == ''){
      setEmailError('Email Required')
    }
    if(password == ''){
      setPasswordError('Password Required')
    }
    if(email !== '' && password !== ''){
      setProxyToken(null);   // update state for future renders
      getTokenUser(null);    // ✅ pass it directly
    }
  };

  const submitKey = (e) => {
    if(e.key == 'Enter') {
      submitValue();
    }
  };

  async function confirmEmail(e) {
    console.log("confirmEmail", e);
  }

  useEffect(()=>{
    const { token, doc_type_id, order_id } = props.url_params || {};
    const user_token = secureLocalStorage.getItem('user_token');

    if (token || doc_type_id || order_id) {
      setshowLoginForm(false);
      setLoading(true);
    }
    else if (user_token && !proxyToken) {
      console.log('User token found, redirecting to document page');
      navigate('/document');
      return; // stop execution if not logged in
    }
    else{
      setshowLoginForm(true);
      setLoading(false);
    }

    if(proxyToken){
      consoleLog('proxyToken useEffect proxyToken', proxyToken);
      getTokenUser(proxyToken);
    }
  }, []);

  return (
    <>
      { loading ? ( 
        <LoadingContainer>
          <img className="loader" src={Loader} alt="Loading..."/>
        </LoadingContainer>
      )
      : showLoginForm ? (
        <FormLogin>
          <MDBContainer className="w-100">
            <MDBRow className="w-100 align-items-center justify-content-center m-0">
              <MDBCol md="4">
                <form className="w-100">
                  <h2 className="login-text text-center">LOG IN</h2>
                  <div className="mb-3 pt-2">
                    <input type="email" className="form-control login-input" placeholder="Email Address" onChange={handleEmailChange} onKeyPress={submitKey} />
                  </div>
                  
                  {emailError &&
                    <div style={{color:'red'}}>{emailError}</div>
                  }

                  <div className="mb-3 pt-2">
                    <input type="password" className="form-control login-input" placeholder="Password" onChange={handlePasswordChange} onKeyPress={submitKey} />
                  </div>

                  <a href="javascript:void(0)" className="forget-link" onClick={() => setShowForgotPasswordModal(true)}>Forgot password</a>
                  
                  {passwordError && <div style={{color:'red', float:'right'}}>{passwordError}</div> }

                  {generaicError && <div style={{color:'red', float:'right', margin:'10px'}} >{generaicError}</div> }

                  <div className="text-center mb-3 pt-4">
                    <Btn onClick={submitValue} active={isButtonActive} disabled={!isButtonActive}>
                      <div className="w-100" style={{ cursor: "pointer" }}>
                        Login
                      </div>
                    </Btn>
                  </div>
                  {process.env.GATSBY_IS_OKTA_ENABLED && (
                    <>
                      {/* Divider with "or log in using" text */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "20px 0",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            height: "1px",
                            background: "#ccc",
                          }}
                        />
                        <span
                          style={{
                            padding: "0 10px",
                            fontSize: "14px",
                            color: "#666",
                            whiteSpace: "nowrap",
                          }}
                        >
                          or log in using
                        </span>
                        <div
                          style={{
                            flex: 1,
                            height: "1px",
                            background: "#ccc",
                          }}
                        />
                      </div>
                  
                      {/* ✅ OKTA LOGIN BUTTON - only on client */}
                      {isClient && oktaAuth && (
                        <div className="text-center mb-3">
                          <img
                            onClick={() => oktaAuth.signInWithRedirect()}
                            src={oktassoicon}
                            title="Sign in with OKTA"
                            alt="Sign in with OKTA"
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </>
                   )}

                  <div className="create-account-link text-center pt-3">
                    <a href="https://roofscope.com/customer/register" target="_blank" rel="noreferrer" className="create-account-link text-center">
                      Create Account
                    </a>
                  </div>
                </form>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </FormLogin>
      
      ) : null}
      {
        showForgotPasswordModal &&
        <ForgotPassword
          showModal={showForgotPasswordModal}
          setShowModal={setShowForgotPasswordModal}
          confirm={confirmEmail}
        />
      }
    </>
  )
};

export default Login;

// --- Styled Components ---
const LoadingContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  .loader {
    -webkit-user-select: none;
    margin: auto;
  }
`;

const FormLogin = styled.div`
  .login-text {
    font-family: Rajdhani;
    font-weight: bold !important;
    font-size: 25px;
    letter-spacing: 0px;
    color: #212E33;
    text-transform: uppercase;
    opacity: 1;
  }
  .login-input {
    background: #FFFFFF !important;
    border: 1px solid #B4BEBF !important;
    border-radius: 3px !important;
    opacity: 1;
  }
  input[type="text"], input[type="email"], input[type="password"] {
    height: 48px !important;
    font-size: 14px !important;
    letter-spacing: 0px;
    line-height: 24px;
    color: #414243 !important;
    font-family: Roboto;
    outline: none;
  }
  .forget-link {
    text-decoration: underline;
    color: #212e3380;
    font-size: 16px;
    line-height: 24px;
  }
  .create-account-link {
    text-decoration: underline;
    color: #14848E;
    font-size: 14px;
    line-height: 18px;
    font-family: 'Roboto';
  }

  width: 100%;
  height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Btn = styled.div`
  height: 48px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.active ? "#DE841E" : "#D6E1E5")};
  color: ${(props) => (props.active ? "#ffffff" : "#737F82")};
  font: normal normal 600 16px / 21px Rajdhani;
  letter-spacing: 0.6px;
  width: 100%;
  border-radius: 3px;
  opacity: 1;
  &:hover {
    background-color: #DE841E !important;
    color: #ffffff !important;
  }
`;